import { LOADMAP } from "../constants/Map";

export const storeMapInformation = (map) => {
    return {
        type: LOADMAP,
        payload: map,
    };
};